<template>
  <div class="form-group" :class="className">
    <label class="gf_col-sm-4 gf_col-md-5" v-if="!hideTitle">{{title}}</label>
    <div class="switch">
      <input
        type="checkbox"
        v-model="val"
        @input="onInput"
        @change="onChange"
        v-bind="attrs"
        v-on="listeners"
        :disabled="readonly"
      />
      <span class="slider"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToggleSwitch",
  props: {
    title: String,
    placeholder: String,
    value: Boolean,
    className: {
      type: String,
      default: "gf_col-sm-12 gf_col-md-12"
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hideTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: ""
    };
  },
  computed: {
    listeners() {
      const { input, onChange, ...listeners } = this.$listeners;
      return listeners;
    },
    attrs() {
      const { rows, ...attrs } = this.$attrs;
      return attrs;
    }
  },
  methods: {
    onInput(e) {
      // let value = e.target.value;
      // console.log(e.target.value);
      this.$emit("input", this.val);
    },
    onChange(e) {
      this.$emit("input", this.val);
      this.$emit("change", this.val);
    }
  },
  created() {
    this.val = this.value;
  },
  watch: {
    value(newV) {
      this.val = newV;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/_variables.scss";
.switch {
  position: relative;
  display: inline-block;
  width: 96px;
  height: 40px;

  input {
    width: 100%;
    height: 100%;
    margin: 0;
    position: absolute;
    z-index: 100;
    opacity: 0;
    cursor: pointer;

    &:checked {
      &+.slider:after {
        position: absolute;
        content: "YES";
        color: #FFFFFF;
        -webkit-transition: .4s;
        transition: all .4s;
        right: calc(32px + 13px);
        left: auto;
      }

      &+.slider {
        background-color: $blue;
      }

      &+.slider:before {
        content: "";
        -webkit-transform: translateX(calc(200% - 8px));
        -ms-transform: translateX(calc(200% - 8px));
        transform: translateX(calc(200% - 8px));
      }
    }

    &:disabled {
      cursor: not-allowed;
    }
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #EEEEEE;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 30px;

    &:before {
      position: absolute;
      content: "";
      height: 32px;
      width: 32px;
      left: 4px;
      bottom: 4px;
      background-color: white;
      border-radius: 50%;
      -webkit-transition: .4s;
      transition: all .4s;
    }

    &:after {
      position: absolute;
      content: "NO";
      color: #555;
      -webkit-transition: .4s;
      transition: all .4s;
      left: calc(32px + 13px);
      top: calc(50% - 7px);
      right: auto;
      bottom: auto;
      font: inherit;
      font-size: 14px;
      font-weight: bold;
    }
  }

  .slider--lock {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #EEEEEE;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 30px;

    &:before {
      position: absolute;
      content: "";
      height: 32px;
      width: 32px;
      left: 4px;
      bottom: 5px;
      background: url("data:image/svg+xml,%3Csvg width='36' height='36' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_d)'%3E%3Ccircle cx='17' cy='18' r='16' fill='white'/%3E%3C/g%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.1667 16.8337V23.8337H22.8333V16.8337H11.1667ZM10.7778 15.667C10.3482 15.667 10 16.0152 10 16.4448V24.2225C10 24.6521 10.3482 25.0003 10.7778 25.0003H23.2222C23.6518 25.0003 24 24.6521 24 24.2225V16.4448C24 16.0152 23.6518 15.667 23.2222 15.667H10.7778Z' fill='%23DADADA'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.7041 13.2362C13.1043 14.2024 12.9167 15.4394 12.9167 16.4448H11.75C11.75 15.3328 11.9514 13.8476 12.7128 12.6209C13.4997 11.3533 14.8537 10.417 17.0001 10.417C19.1465 10.417 20.5005 11.3533 21.2873 12.6209C22.0487 13.8476 22.25 15.3329 22.25 16.4448L21.0833 16.4448C21.0834 15.4394 20.8958 14.2024 20.2961 13.2362C19.7218 12.311 18.7425 11.5837 17.0001 11.5837C15.2578 11.5837 14.2784 12.311 13.7041 13.2362Z' fill='%23DADADA'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M17.0003 19.5557C17.3225 19.5557 17.5837 19.8168 17.5837 20.139V21.6946C17.5837 22.0167 17.3225 22.2779 17.0003 22.2779C16.6782 22.2779 16.417 22.0167 16.417 21.6946V20.139C16.417 19.8168 16.6782 19.5557 17.0003 19.5557Z' fill='%23DADADA'/%3E%3Cdefs%3E%3Cfilter id='filter0_d' x='0' y='0' width='36' height='36' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3E%3CfeOffset dx='1'/%3E%3CfeGaussianBlur stdDeviation='1'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/%3E%3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E%0A") no-repeat;
      border-radius: 50%;
      -webkit-transition: .4s;
      transition: all .4s;
    }

    &:after {
      position: absolute;
      content: "NO";
      color: #BEBEBE;
      -webkit-transition: .4s;
      transition: all .4s;
      left: calc(32px + 13px);
      top: calc(40% - 5px);
      right: auto;
      bottom: auto;
      font-size: 14px;

    }
  }
}
</style>